export default {
  fillColor: 'var(--color-primaryLight)'
}
